export default __webpack_public_path__ + "static/media/static-register.63408385.svg";